
import { QueryClientProvider, QueryClient } from 'react-query';
import { BaseLayout } from "components/layout-components/BaseLayout";
import { Dashboard } from "pages/Dashboard";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { Statement } from 'pages/Statement';
import {ScrollTop} from 'components/layout-components/ScrollTop';

function App() {
  const queryClient = new QueryClient();



  return (

    <QueryClientProvider client={queryClient}>

      <BrowserRouter>
        <ScrollTop />
        <BaseLayout>
          <Routes>
            <Route path="" element={<Dashboard />} />
            <Route path="/statement" element={<Statement />} />
          </Routes >
        </BaseLayout>
      </BrowserRouter>

    </QueryClientProvider >

  );
}

export default App;
